export enum SensorUdiEnum {
    LUER = 'LUER',
    NRFIT = 'NRFIT',
}
